export default "__VITE_ASSET__be54b42f__"